var e="-ms-",m="-moz-",r="-webkit-",o="comm",a="rule",l="decl",t="@import",c="@keyframes",i="@layer";export{o as COMMENT,l as DECLARATION,t as IMPORT,c as KEYFRAMES,i as LAYER,m as MOZ,e as MS,a as RULESET,r as WEBKIT};
//# sourceMappingURL=Enum.js.map
